import { IDmLoaiDangKyHoc } from "../../model/respone/category/IDmLoaiDangKyHoc";
import { apiClient } from "../apiClient";

export const LOAI_DANG_KY_HOC_ENDPOINT = "loai-dang-ky-hoc";

export const dmLoaiDangKyHocApi = {
  SelectAll: () => apiClient.get(`${LOAI_DANG_KY_HOC_ENDPOINT}`),
  Insert: (payload: IDmLoaiDangKyHoc) =>
    apiClient.post(`${LOAI_DANG_KY_HOC_ENDPOINT}`, payload),
  Update: (payload: IDmLoaiDangKyHoc) =>
    apiClient.put(`${LOAI_DANG_KY_HOC_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${LOAI_DANG_KY_HOC_ENDPOINT}/${id}`),
};
